import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedService, JackpotService } from 'baseline-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { Global } from '../../../global/global';
import { Subscription} from 'rxjs';
import {Observable} from 'rxjs/Rx';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoadingController} from 'ionic-angular';
import { HomePage } from '../../home/home/home';


/**
 * Generated class for the JackpotDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-jackpot-detail',
  templateUrl: 'jackpot-detail.html',
})
export class JackpotDetailPage {
  jevent: any;
  subs: Subscription;
  loader : any;


  constructor(public navCtrl: NavController, public navParams: NavParams,
    private _sharedService: SharedService,private jackpotService: JackpotService,
    private translate : TranslateService,public globalData:Global,
    public toast: CustomToast, public loadingCtrl: LoadingController,
    public modalCtrl : ModalController) {
      this.jevent = navParams.get('data');
     
  }

  refresh(jeventparam : any) {
    this.subs = Observable.interval(2000)
      .subscribe((val) => {
        this.getstatus(jeventparam);
      })
  }

  getstatus(jeventparam : any){
    setTimeout(() => { 
      if (this.jackpotService._notify.errorMsg || this.jackpotService._notify.successMsg) {
        if(this.loader){
          this.loader.dismiss();
        }
        this.subs.unsubscribe();
        if(this.jackpotService._notify.errorMsg){
          this.toast.showError(this.jackpotService._notify.errorMsg);
        }else{
          this.toast.showSuccess(this.jackpotService._notify.successMsg);
          this.jackpotService.clearAllSelection(jeventparam);
          this.globalData.selectedMenu = "jackpot";
          this.navCtrl.pop();
        }
      }
    }, 500);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JackpotDetailPage');
  }

  buyTicket(jeventparam : any)
  {
    if (this.globalData.isLoggedIn && this.globalData.authUser)
    {
       this.loader = this.loadingCtrl.create({
        content: "Please Wait",
      });
      this.loader.present();
      this.refresh(jeventparam);
      this.jackpotService.buyTicket(jeventparam);
    }
    else
    {
      let profileModal = this.modalCtrl.create(LoginModalPage);
      profileModal.present();    
    }
  }
  
  // ngOnDestroy() {
  //   this.jackpotService.clearJackpotData();
  // }

}



// WEBPACK FOOTER //
// ./src/app/sports/jackpot-detail/jackpot-detail.ts